import { USER_TYPE, getProfile } from "@/api/user";
import _ from "lodash";
const { dealer } = USER_TYPE;

export default {
  namespaced: true,
  state: {
    user: null,
    accentColor: "",
    inFavorites: null,
    languages: [
      {
        code: "ua",
        label: "Українська",
        slug: "Укр",
      },
      {
        code: "ru",
        label: "Русский",
        slug: "Рус",
      },
    ],
    permissions: [],
  },

  getters: {
    userId(state) {
      return state.user.id;
    },

    getPermission(state) {
      return _.mapValues(_.keyBy(state.permissions, "nameOriginal"), "isActive");
    },

    userProfile(state) {
      return state.user;
    },

    userProfileName(state) {
      const firstName = state.user.firstName;
      const lastName = state.user.lastName;

      return `${firstName} ${lastName}` || "";
    },

    userProfileEmail(state) {
      return state.user.email;
    },

    userPhone(state) {
      return state.user.phone;
    },

    userAvatar(state) {
      return state.user.avatar;
    },

    userManager(state) {
      return state.user.detail?.company?.oneCEmployee;
    },

    languages(state) {
      return state.languages;
    },

    backgroundImage(state) {
      return state.user?.imageName || "";
    },

    balance(state) {
      return state.user.balance;
    },

    isUserDealer(state) {
      return state.user.type === dealer;
    },

    isUserDealerAdmin(state) {
      return state.user.roles[0].code === "dealerAdmin";
    },
  },

  mutations: {
    SET_PROFILE(state, user = {}) {
      state.user = user;
      state.permissions = user.permissions;
      state.inFavorites = state.user.favoriteProductsCount;
    },

    SAVE_USER_DEALER_STATE(state, userType) {
      window.localStorage.setItem("isUserDealer", Number(userType === dealer));
    },

    SET_IN_FAVORITES(state, count) {
      state.inFavorites = count;
    },
  },

  actions: {
    async getProfile(context) {
      const response = await getProfile();

      window.localStorage.setItem("permissions", JSON.stringify(response.permissions));

      context.commit("SET_PROFILE", response);
    },

    removeProfile(context) {
      context.commit("SET_PROFILE");
    },

    setInFavoritesCount(context, count) {
      context.commit("SET_IN_FAVORITES", count);
    },
  },
};
